var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraftPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.5H4.5V2.5H13.7929L19.5 8.20711V21.5Z",
    stroke: "#181818"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3733_38947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3733_38947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 17.2499L12.1754 16H16.7504V17.2499H10.625ZM8.0504 16.4501H8.7002L13.2254 11.9375L12.563 11.2751L8.0504 15.8003V16.4501ZM14.9126 11.3873L13.1126 9.5753L13.6874 9.0125C13.8458 8.8541 14.0334 8.7749 14.2502 8.7749C14.467 8.7749 14.6586 8.8541 14.825 9.0125L15.4874 9.6749C15.6378 9.8333 15.713 10.0271 15.713 10.2563C15.713 10.4855 15.6338 10.6751 15.4754 10.8251L14.9126 11.3873ZM14.363 11.9375L9.05 17.2499H7.25V15.4499L12.563 10.1375L14.363 11.9375ZM12.9002 11.6129L12.563 11.2751L13.2254 11.9375L12.9002 11.6129Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftPage);
export default __webpack_public_path__ + "static/media/draft_page.155dd0900688f91343fb23e0532beb97.svg";
export { ForwardRef as ReactComponent };